import { createApiCall, IAxiosRequestConfig } from 'services'
import { AnyType, GetRequest, MutateOperation, MutateRequest } from '@centra/centra-ui'

interface IEntityRequestConfig extends IAxiosRequestConfig {
  data?: GetRequest | MutateOperation | MutateRequest | undefined | AnyType
}

export const entityApiCall = ({
  apiType = 'general',
  method = 'GET',
  url = '',
  data,
  ...rest
}: IEntityRequestConfig) => {
  return createApiCall({ apiType, method, url, data, ...rest })
}
